import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const Card = styled(Flex as any)<ICardTheme>`
  border: none;
  border-radius: 8px;
  flex-direction: column;
  min-width: 370px;
  max-width: 550px;

  display: block;

  width: 40vw;

  ${is('withShadow')`
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  `};
  ${is('withBackgroundColor')`
    background-color: ${({ withBackgroundColor }: ICardTheme) =>
      withBackgroundColor};
  `};

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    min-width: 0;
    width: 100%;
    margin: 0px 10px;
  }
`

export default Card

export interface ICardTheme {
  withShadow?: boolean
  withBackgroundColor?: string
}
